import { Button, Dialog, Grid, Link, Stack, Typography } from "@mui/material";
import React from "react";
import { closeDialog, openDialog } from "src/store/features/BrokerToCustomerDialog.slice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";
import api from "src/store/features/api";

export const useDialogStyles = makeStyles((theme: Theme) => ({
  paperProps: {
    // desktop styles
    borderRadius: "10px",
    width: "450px",
    padding: "20px",
    // mobile styles
    [theme.breakpoints.down("md")]: {
      borderRadius: "0px",
      minHeight: "100%",
      minWidth: "100%",
    },
  },
  submitButton: {
    textTransform: "none",
    marginTop: "15px",
    width: "70%",
    height: "30px",
    background: theme.palette.secondary.main,
    color: "#fff",
    fontSize: "14px",
    // mobile styles
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
    "&:hover": {
      background: "#FEDBDB",
      boxShadow: "none",
    },
  },
}));

const AreYouTalkingWithABrokerDialog = () => {
  const classes = useDialogStyles();
  const dispatch = useAppDispatch();
  const isCustomerTalkingWithBroker = useAppSelector(
    (state): boolean => state.user.isCustomerTalkingWithBroker,
  );
  const dialogOpen = useAppSelector((state): boolean => state.brokerToCustomerDialog.isOpen);
  const [NotifyBroker, { isError, error }] = api.useNotifyBrokerCallMutation();

  const [rejected, setRejected] = React.useState<boolean>(false);

  const handleClose = (): void => {
    dispatch(closeDialog());
  };

  const callSalesforce = async (confirmation: boolean): Promise<void> => {
    await NotifyBroker({ notifyBrokerCallDto: { confirmation } });
  };

  React.useEffect(() => {
    if (isCustomerTalkingWithBroker) dispatch(openDialog());
  }, [isCustomerTalkingWithBroker]);

  React.useEffect(() => {
    if (isError) console.log(error);
  }, [isError, error]);

  // ------------------------ Helper Components ------------------------

  const LockImage = () => {
    return (
      <Grid container item justifyContent="center" alignItems="center">
        <Grid item>
          <img
            src="/static/image/securityLock.png"
            alt="Secure lock"
            height="100px"
            width="100px"
          />
        </Grid>
      </Grid>
    );
  };

  const ConfirmationText = ({ text, marginTop, extraPadding }: any) => (
    <>
      {!marginTop ? (
        <Grid item>
          <Typography align="center" sx={{ fontSize: "14px", padding: extraPadding ?? "" }}>
            {text}
          </Typography>
        </Grid>
      ) : (
        <Grid item container justifyContent="center" sx={{ marginTop }}>
          <Typography align="center" sx={{ fontSize: "14px" }}>
            {text}
          </Typography>
        </Grid>
      )}
    </>
  );

  const ConfirmationButton = ({ onClick, label, isLink, linkLabel, marginTop }: any) => (
    <>
      {isLink ? (
        <Link
          component="button"
          variant="caption"
          onClick={onClick}
          sx={{ marginTop: marginTop }}
          color="primary">
          {linkLabel}
        </Link>
      ) : (
        <Button disableRipple onClick={onClick} className={classes.submitButton}>
          {label}
        </Button>
      )}
    </>
  );

  return (
    <Dialog open={dialogOpen} PaperProps={{ className: classes.paperProps }}>
      {rejected ? (
        <Stack spacing={4}>
          <LockImage />
          <ConfirmationText
            extraPadding="0px 25px"
            text="Thank you for your response. For security reasons, we've notified your broker about the declined confirmation. If you have any concerns or need assistance, feel free to contact your broker directly."
          />
          <Grid container justifyContent="center" alignItems="center">
            <ConfirmationButton
              onClick={(): void => {
                handleClose();
              }}
              label="Close"
            />
          </Grid>
        </Stack>
      ) : (
        <Stack spacing={4}>
          <LockImage />
          <Grid container>
            <ConfirmationText text="To better improve security practices, your broker has requested for you to confirm you are logged into the Portal." />
            <ConfirmationText
              text="Please confirm you are currently speaking to your broker."
              marginTop="20px"
            />
          </Grid>

          <Grid container justifyContent="center" alignItems="center">
            <ConfirmationButton
              onClick={(): void => {
                handleClose();
                callSalesforce(true);
              }}
              label="Confirm"
            />

            <ConfirmationButton
              onClick={(): void => {
                setRejected(true);
                callSalesforce(false);
              }}
              label="I am not speaking with Caleb & Brown"
              isLink
              linkLabel="I am not speaking with Caleb & Brown"
              marginTop="10px"
            />
          </Grid>
        </Stack>
      )}
    </Dialog>
  );
};

export default AreYouTalkingWithABrokerDialog;
